import script from "./deploymentTable.vue?vue&type=script&setup=true&lang=js"
export * from "./deploymentTable.vue?vue&type=script&setup=true&lang=js"

import "./deploymentTable.vue?vue&type=style&index=0&id=f43407e6&lang=css"

const __exports__ = script;

export default __exports__